import { Facebook, Instagram, Youtube, MapPin, MessageCircle, Mail } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import Crest from "@/components/Crest";
import { MENU, WHATSAPP_URL, SOCIALS } from "@/data/content";
import { scrollToId } from "@/lib/scroll";

const LEGAL_LINKS = ["Política de Privacidade", "Proteção de Dados – LGPD", "Termos de Uso"];

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const go = (id) => {
    if (id === "documentos" || id === "comunidades") {
      navigate(`/${id}`);
      return;
    }
    if (location.pathname !== "/") {
      navigate(`/#${id}`);
      return;
    }
    scrollToId(id);
  };
  return (
    <footer id="contato" className="bg-[#2E070D] text-[#FBF9F4]">
      <div className="px-4 sm:px-8 lg:px-16 py-16 lg:py-24 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3">
            <img src="/brasao-dacb-oficial.webp" alt="Brasão oficial da Diocese Anglicana Católica do Brasil" className="h-16 w-auto shrink-0 object-contain" />
            <div>
              <p className="font-display text-lg font-bold leading-tight">Diocese Anglicana Católica do Brasil</p>
              <p className="overline-label text-[#C5A059]">A serviço do Evangelho e do povo brasileiro</p>
            </div>
          </div>
          <blockquote className="mt-8 border-l-2 border-[#C5A059] pl-5">
            <p className="font-liturgy italic text-2xl text-[#FBF9F4]/85">«Para que todos sejam um»</p>
            <cite className="overline-label text-[#C5A059] not-italic">Jo 17,21</cite>
          </blockquote>
          <div className="mt-8 flex gap-3">
            <a data-testid="footer-social-facebook" href={SOCIALS.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="p-2.5 border border-[#C5A059]/30 hover:border-[#C5A059] hover:text-[#C5A059] transition-colors"><Facebook className="h-4 w-4" /></a>
            <a data-testid="footer-social-instagram" href={SOCIALS.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="p-2.5 border border-[#C5A059]/30 hover:border-[#C5A059] hover:text-[#C5A059] transition-colors"><Instagram className="h-4 w-4" /></a>
            <a data-testid="footer-social-youtube" href={SOCIALS.youtube} target="_blank" rel="noreferrer" aria-label="YouTube" className="p-2.5 border border-[#C5A059]/30 hover:border-[#C5A059] hover:text-[#C5A059] transition-colors"><Youtube className="h-4 w-4" /></a>
          </div>
        </div>

        <div className="lg:col-span-3">
          <p className="overline-label text-[#C5A059]">Navegação</p>
          <ul className="mt-6 space-y-3">
            {MENU.map((m) => (
              <li key={m.id}>
                <a
                  data-testid={`footer-link-${m.id}`}
                  href={m.id === "documentos" || m.id === "comunidades" ? `/${m.id}` : `/#${m.id}`}
                  onClick={(e) => {
                    e.preventDefault();
                    go(m.id);
                  }}
                  className="text-sm text-[#FBF9F4]/70 hover:text-[#C5A059] transition-colors"
                >
                  {m.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <p className="overline-label text-[#C5A059]">Contato</p>
          <ul className="mt-6 space-y-4 text-sm text-[#FBF9F4]/70">
            <li className="flex gap-3">
              <MapPin className="h-4 w-4 mt-0.5 shrink-0 text-[#C5A059]" />
              <span>Sé Primacial — Rua 1, nº 650, Monte Sinai<br />Esmeraldas — Minas Gerais</span>
            </li>
            <li>
              <a data-testid="footer-whatsapp-link" href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="flex gap-3 hover:text-[#C5A059] transition-colors">
                <MessageCircle className="h-4 w-4 mt-0.5 shrink-0 text-[#C5A059]" />
                <span>WhatsApp Pastoral</span>
              </a>
            </li>
            <li>
              <a data-testid="footer-email-link" href="mailto:chancelaria@dacb.org.br" className="flex gap-3 hover:text-[#C5A059] transition-colors">
                <Mail className="h-4 w-4 mt-0.5 shrink-0 text-[#C5A059]" />
                <span>chancelaria@dacb.org.br</span>
              </a>
            </li>
          </ul>
          <p className="overline-label mt-10 text-[#C5A059]">Comunhão</p>
          <img src="/brasao-afci-oficial.webp" alt="Brasão oficial da Anglican Free Communion International" className="mt-4 h-28 w-auto object-contain" loading="lazy" />
          <p className="mt-3 text-sm text-[#FBF9F4]/70">Anglican Free Communion International</p>
        </div>
      </div>

      <div className="border-t border-[#C5A059]/15 px-4 sm:px-8 lg:px-16 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p data-testid="footer-copyright" className="text-xs text-[#FBF9F4]/50">© 2026 DACB. Todos os direitos reservados.</p>
        <div className="flex flex-wrap gap-6">
          {LEGAL_LINKS.map((l) => (
            <a key={l} data-testid={`footer-legal-${l.split(" ")[0].toLowerCase()}`} href="#" className="text-xs text-[#FBF9F4]/50 hover:text-[#C5A059] transition-colors">{l}</a>
          ))}
        </div>
      </div>
    </footer>
  );
}
